import { TransitionMaskedIcon } from './TransitionMaskedIcon';

/**
 * author: Google
 * id D254EE82-37CA-4897-BE12-6FD0ED708E38
 * name transition-masked
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/transition-masked.svg
 * tags
 */
export const MaskedTransitionsIcon = TransitionMaskedIcon;
export default MaskedTransitionsIcon